import type { CardInstance, CardDefinition, Faction } from '../../types/kotch';
import { CARD_DEFINITIONS } from '../../data/kotch/cards';
import { FACTION_INFO } from '../../data/kotch/factionDecks';
import Card, { MiniCard } from './Card';

interface OpponentHandProps {
  cards: CardInstance[];
  playerName: string;
  revealedCards?: string[];  // instanceIds of cards revealed to viewing player
  playerFaction?: Faction | null;
  onCardHover?: (def: CardDefinition | null) => void;
}

export default function OpponentHand({ cards, playerName, revealedCards = [], playerFaction, onCardHover }: OpponentHandProps) {
  const factionInfo = playerFaction ? FACTION_INFO[playerFaction] : null;

  return (
    <div
      className={`kotch-opponent-area ${factionInfo ? 'faction-accented' : ''}`}
      style={factionInfo ? { '--faction-color': factionInfo.themeColor } as React.CSSProperties : undefined}
    >
      <div className="kotch-opponent-hand">
        {cards.map((card) => {
          const def = CARD_DEFINITIONS[card.definitionId];
          const isRevealed = revealedCards.includes(card.instanceId);

          if (isRevealed) {
            // Show revealed cards face-up with special styling
            return (
              <Card
                key={card.instanceId}
                card={card}
                faceUp={true}
                revealed={true}
                size="small"
                playerFaction={playerFaction}
                onHover={onCardHover}
              />
            );
          }

          return (
            <MiniCard
              key={card.instanceId}
              isSpecial={def?.category === 'special'}
            />
          );
        })}
      </div>
      <div className="kotch-hand-count">
        {playerName}: {cards.length} card{cards.length !== 1 ? 's' : ''}
      </div>
    </div>
  );
}
